import { View, ViewModel } from "binder";
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class MeasureParameterSearchableSelector extends SearchableSelectorBaseViewModel<MeasureParameter>{
    
    public getTypeId(): string {return '';}
    constructor(parent:ViewModel, measureParamterGroupId:string) {
        super(parent);
        this.groupId = measureParamterGroupId;
    }
    
    public set groupId(v: string) { this._groupId = v; } public get groupId(): string { return this._groupId;} private _groupId: string;

    protected async loadData(searchedText: string): Promise<MeasureParameter[]> {
        let result = await ServerConnection.callServer('/Complex/ControlPlanService/SearchMeasureParameterByMeasureParameterGroupId',{
            MeasureParameterGroupId : this.groupId,
            SearchText : searchedText,
            ResultCount : 5
        });

        return result.MeasureParameters.map(item => this.convertToMeasureParameter(item));
    }

    protected async loadById(id: string): Promise<MeasureParameter> {
        let result = await ServerConnection.callServer('/Complex/ControlPlanService/GetMeasureParameterById',{
            Id:id
        });

        return this.convertToMeasureParameter(result.MeasureParameter);
    }

    convertToMeasureParameter(dto:any):MeasureParameter{
        let measureParameter:MeasureParameter = new MeasureParameter(this);
        measureParameter.id = dto.Id;
        measureParameter.title = dto.Name;
        measureParameter.name = dto.Name;
        measureParameter.unitName = dto.Unit;
        measureParameter.measurementMethod = dto.MeasurementMethod;
        return measureParameter;
    }

    override async refresh(): Promise<void> {
        this.selectedItem = null;
    }
    
}

export class MeasureParameter extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName;} private _unitName: string;
    public set measurementMethod(v: string) { this._measurementMethod = v; } public get measurementMethod(): string { return this._measurementMethod;} private _measurementMethod: string;
    
}